<template>
  <div>
    <Loading v-if="isLoading" :type="3" />
    <b-row v-else>
      <div
        v-if="dataServers[0] == null || dataServers[0].length == 0"
        class="h-100 w-100 my-auto pt-lg-0 pt-3 text-muted"
      >
        <h1 class="text-center">
          <i class="big icon database"></i>
        </h1>
        <h1 class="text-center">
          {{ "sections.GenericList.serverNoData" | i18n }}
        </h1>
      </div>
      <div
        v-else
        v-for="column in dataServers"
        v-bind:key="column.nom"
        class="column"
      >
        <div
          v-for="data in column"
          v-bind:key="data.id"
          class="pt-4 pl-4"
          id="column"
        >
          <div
            class="server-header mb-4 pointer border-bottom p-1"
            @click="
              () => {
                data.visible = !data.visible;
                $forceUpdate(); // Necessary since props updating
              }
            "
          >
            <div>
              <h6 class="font-weight-light text-muted mb-0">
                <i class="wifi icon mr-2"></i>{{ data.ip }}
              </h6>
              <h4 class="text-break mb-0 my-1">{{ data.nom }}</h4>
              <h6 class="font-weight-normal" cols="3" md="2">
                {{ "components.servers.cpuUsage" | i18n }}
                {{ data.moyenne_CPU }}%
              </h6>
            </div>
            <i class="icon big caret" :class="data.visible ? 'up' : 'down'"></i>
          </div>
          <b-collapse
            :id="'server-' + data.id"
            :visible="data.visible"
            class="mt-2"
          >
            <ServerDiskState :serverId="data.id" />
            <div class="d-flex">
              <GenericFormUpdate
                :objectId="data.id"
                class="mr-2"
                :modalId="2"
                :clientId="'' + clientId"
              />
              <GenericFormDelete
                :deleteFunction="$api.deleteServer"
                :objectId="data.id"
                :modalId="'modalServer-' + data.id"
                :reloadOnSucces="true"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script>
import ServerDiskState from "./ServerDiskState.vue";
import GenericFormDelete from "../generics/GenericFormDelete.vue";
import GenericFormUpdate from "../generics/GenericFormUpdate.vue";
import Loading from "../others/Loading.vue";
/**
 * @description Composante qui donne la description d'un serveur
 * @author Benjamin Caron
 * @author Samuel Colassin
 * @author Francine Jin
 * @vue-prop {Number} clientId - L'id du client
 * @vue-data {Array} dataServers - Les données du serveur
 * @vue-data {Boolean} isLoading - Si la page est en chargement
 */
export default {
  components: {
    GenericFormUpdate,
    ServerDiskState,
    GenericFormDelete,
    Loading
  },
  props: {
    clientId: {
      type: Number,
      required: true
    }
  },
  /**
   * @description Permet d'obtenir les serveurs avant le chargement de la page
   */
  beforeMount() {
    this.getServers();
  },
  data() {
    return {
      dataServers: [],
      isLoading: true
    };
  },
  methods: {
    /**
     * @description Fonction qui va chercher les serveurs du client dans l'api
     */
    async getServers() {
      await this.$api
        .getAllServersByClient(this.clientId)
        .then(res => {
          this.dataServers = res.data.data;
          let leftColumn = [];
          let rightColumn = [];
          for (let col = 0; col < this.dataServers.length; col++) {
            this.dataServers[col].visible = false;
            if (col % 2 == 0) {
              leftColumn.push(this.dataServers[col]);
            } else {
              rightColumn.push(this.dataServers[col]);
            }
          }
          this.dataServers = [leftColumn, rightColumn];
          this.isLoading = false;
          this.$emit("doneLoading");
        })
        .catch();
    },
    /**
     * @description Fonction qui donne la bonne couleur de point selon le pourcentage
     * @param {String} average Le pourcentage
     * @returns {String} La couleur en texte
     */
    getVariant(average) {
      let color;
      average = parseInt(average);
      color = average > 85 ? "danger" : average > 70 ? "warning" : "success";
      return "text-" + color;
    }
  }
};
</script>

<style scoped lang="scss">
.circle {
  font-size: 45px;
  margin-top: -5px;
  margin-left: -3px;
}

.column {
  width: 45% !important;
  margin: 20px;
}

#circle {
  font-size: 31px;
  margin: auto;
}

#outline {
  font-size: 45px;
}

.server-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.server-header:hover {
  background: $gray-100;
}

@media screen and (max-width: 1365px) {
  .column {
    width: 100% !important;
    margin: 3%;
    padding-top: 0 !important;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  #column {
    padding-right: 0 !important;
  }
}
</style>
